// initial state
import Login from '../../views/account/Login.vue';

const siteTitle = 'Addsoft';
const delimiter = '-';
const state = {
    routes: [
        {
            path: '/',
            name: 'Inloggen',
            component: Login,
            meta: {
                title: `Inloggen ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        {
            path: '/login/:token',
            name: 'Activeren',
            component: () => import(/* webpackChunkName: "login" */ '../../views/account/Login.vue'),
            meta: {
                title: `Activeren ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        {
            path: '/register',
            name: 'Registreren',
            component: () => import(/* webpackChunkName: "register" */ '../../views/account/Register.vue'),
            meta: {
                hideFooter: true,
                title: `Registreren ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        // locations
        {
            path: '/admin/locations',
            name: 'Vestigingen',
            component: () => import(/* webpackChunkName: "locations" */ '../../views/locations/List.vue'),
            meta: {
                title: `Vestigingen ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        {
            path: '/admin/locations/add',
            name: 'Vestiging toevoegen',
            component: () => import(/* webpackChunkName: "locations-add" */ '../../views/locations/Add.vue'),
            meta: {
                title: `Vestiging toevoegen ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        {
            path: '/admin/locations/:id/update',
            name: 'Vestiging bewerken',
            component: () => import(/* webpackChunkName: "locations-update" */ '../../views/locations/Update.vue'),
            meta: {
                title: `Vestiging bewerken ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        // subscriptions
        {
            path: '/admin/subscriptions',
            name: 'Abonnementen',
            component: () => import(/* webpackChunkName: "subscriptions" */ '../../views/subscriptions/List.vue'),
            meta: {
                title: `Abonnementen ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        {
            path: '/admin/subscriptions/:id/update',
            name: 'Abonnement bewerken',
            component: () => import(/* webpackChunkName: "subscriptions-update" */ '../../views/subscriptions/Update.vue'),
            meta: {
                title: `Abonnement bewerken ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        {
            path: '/admin/subscription/terms',
            name: 'Abonnementsvoorwaarden',
            component: () => import(/* webpackChunkName: "subscriptions-update" */ '../../views/subscriptions/Terms.vue'),
            meta: {
                title: `Abonnementsvoorwaarden ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        // licenses
        {
            path: '/admin/licenses/:ProductID/:AbonnementID',
            name: 'Licenties',
            component: () => import(/* webpackChunkName: "licenses" */ '../../views/licenses/List.vue'),
            meta: {
                title: `Licenties ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        // storec mobiel
        {
            path: '/admin/storec-mobiel',
            name: 'Storec Mobiel',
            component: () => import(/* webpackChunkName: "storec-mobiel" */ '../../views/storec-mobiel/List.vue'),
            meta: {
                title: `Storec Mobiel ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        {
            path: '/admin/storec-mobiel/locations',
            name: 'Storec Mobiel vestigingen',
            component: () => import(/* webpackChunkName: "storec-mobiel-locations" */ '../../views/storec-mobiel/ListLocations.vue'),
            meta: {
                title: `Storec Mobiel vestigingen ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        {
            path: '/admin/storec-mobiel/add',
            name: 'Storec Mobiel gebruiker toevoegen',
            component: () => import(/* webpackChunkName: "storec-mobiel-add" */ '../../views/storec-mobiel/Add.vue'),
            meta: {
                title: `Storec Mobiel gebruiker toevoegen ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        {
            path: '/admin/storec-mobiel/:id/update',
            name: 'Storec Mobiel gebruiker bewerken',
            component: () => import(/* webpackChunkName: "storec-mobiel-update" */ '../../views/storec-mobiel/Update.vue'),
            meta: {
                title: `Storec Mobiel gebruiker bewerken ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        {
            path: '/admin/storec-mobiel/:id/location',
            name: 'Vestiging gebruikers bewerken',
            component: () => import(/* webpackChunkName: "storec-mobiel-location" */ '../../views/storec-mobiel/UpdateLocation.vue'),
            meta: {
                title: `Vestiging gebruikers bewerken ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        // invoices
        {
            path: '/admin/invoices',
            name: 'Facturen',
            component: () => import(/* webpackChunkName: "invoices-locations" */ '../../views/invoices/ListLocations.vue'),
            meta: {
                title: `Facturen ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        {
            path: '/admin/invoices/:id',
            name: 'Facturen',
            component: () => import(/* webpackChunkName: "invoices" */ '../../views/invoices/ListInvoices.vue'),
            meta: {
                title: `Facturen ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        // profile
        {
            path: '/admin/account',
            name: 'Mijn gegevens',
            component: () => import(/* webpackChunkName: "account" */ '../../views/account/Account.vue'),
            meta: {
                title: `Mijn gegevens ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        {
            path: '/forgot-password',
            name: 'Wachtwoord vergeten',
            component: () => import(/* webpackChunkName: "forgot-password" */ '../../views/account/ForgotPasswordEmail.vue'),
            meta: {
                title: `Wachtwoord vergeten ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        {
            path: '/reset-password/:token',
            name: 'Wachtwoord herstellen',
            component: () => import(/* webpackChunkName: "reset-password" */ '../../views/account/ForgotPasswordReset.vue'),
            meta: {
                title: `Wachtwoord herstellen ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        // agreements
        {
            path: '/admin/agreement/:id',
            name: 'Overeenkomst Addsoft',
            component: () => import(/* webpackChunkName: "agreement" */ '../../views/agreements/Update.vue'),
            meta: {
                title: `Overeenkomst Addsoft ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
        // otherwise redirect to home
        {
            path: '*',
            name: '404 not found',
            component: () => import(/* webpackChunkName: "404-not-found" */ '../../views/404.vue'),
            meta: {
                title: `404 ${delimiter} ${siteTitle}`,
                metaTags: [{
                    name: 'description',
                    content: 'Omschrijving',
                }],
            },
        },
    ],
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {};

export default {
    state,
    getters,
    actions,
    mutations,
};
